// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__18iTs","additionalInfo":"AgreementModal_additionalInfo__PNgrb"};